import { useLayoutEffect, useState, useCallback } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
export const useResizeObserver = (element, callback) => {
    const [width, setWidth] = useState();
    const [height, setHeight] = useState();
    const handleResize = useCallback((entries) => {
        if (!Array.isArray(entries)) {
            return;
        }
        const entry = entries[0];
        if (width !== entry.contentRect.width)
            setWidth(entry.contentRect.width);
        if (height !== entry.contentRect.height)
            setHeight(entry.contentRect.height);
        if (callback) {
            callback(entry.contentRect);
        }
    }, [callback, height, width]);
    useLayoutEffect(() => {
        if (!element) {
            return () => { };
        }
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let RO = new ResizeObserver((entries) => handleResize(entries));
        RO.observe(element);
        return () => {
            RO?.disconnect();
            RO = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [element]);
    return [width, height];
};
//# sourceMappingURL=useResizeObserver.js.map